import {
  BuildSearchRowsArgs,
  BuildSearchRowsResult,
  SearchSections,
} from './types'
import { buildFocusableSection } from './buildFocusableSection'
import { buildAutocompleteSection } from './buildAutocompleteSection'
import { buildDepartmentTabsSection } from './buildDepartmentTabsSection'
import { SearchRow } from '../types'

export const buildSearchRows = ({
  inputValue,
  departments,
  activeDepartment,
  suggestions,
  navigationalSuggestions,
  recentSearches,
  inspirations,
  reminders,
  localiseText,
  maxSuggestions,
  maxNavigationalSuggestions,
}: BuildSearchRowsArgs): BuildSearchRowsResult => {
  const hasTyped = !!inputValue && inputValue.length > 0
  const { index: indexAfterTabs, departmentRows } = buildDepartmentTabsSection({
    departments,
    startIndex: -1,
  })

  const focusableRows = !hasTyped
    ? buildFocusableSection({
        activeDepartment,
        recentSearches,
        inspirations,
        reminders,
        localiseText,
        startIndex: indexAfterTabs,
      })
    : []

  const autocompleteRows = hasTyped
    ? buildAutocompleteSection({
        inputValue,
        activeDepartment,
        suggestions,
        navigationalSuggestions,
        localiseText,
        maxSuggestions,
        maxNavigationalSuggestions,
        startIndex: indexAfterTabs,
      })
    : []

  const sections: SearchSections = {
    departmentRows,
    focusableRows,
    autocompleteRows,
  }

  const flatList: SearchRow[] = [...focusableRows, ...autocompleteRows]

  return { sections, flatList }
}
